import React, { useContext, useEffect, useRef, useState } from 'react';
import { ReactComponent as LeftInActive } from '../../../../assets/home/trvto_leftInActive.svg';
import { ReactComponent as RightActive } from '../../../../assets/home/trvto_RightActive.svg';
import { ReactComponent as OfferTag } from '../../../../assets/icons/offer_tag.svg';
import { ReactComponent as TimmerIcon } from '../../../../assets/icons/trvto_timer_icon.svg';
import './mobileOfferSection.css';
import { OffersContext } from '../../../../context/OffersContext';
import { useNavigate } from 'react-router-dom';
import { getFormattedDateReverse } from '../../../../utils/date';

const MobileOffferSection = ({ data }) => {
    const { setIsOfferPopupOpen, setSelectedOfferId } = useContext(OffersContext);
    const navigate = useNavigate();
    const carouselRef = useRef(null);
    const [slideWidth, setSlideWidth] = useState(0);
    const cardsPerSlide = 1;

    const handleOfferCardClick = (id) => {
        setSelectedOfferId(id);
        setIsOfferPopupOpen(true);
        navigate('/offers');
    };

    useEffect(() => {
        if (carouselRef.current) {
            const containerWidth = carouselRef.current.scrollWidth;
            const calculatedSlideWidth =
                containerWidth / Math.ceil(carouselRef.current.children.length / cardsPerSlide);
            setSlideWidth(calculatedSlideWidth);
        }
    }, []);

    useEffect(() => {
        if (carouselRef.current && carouselRef.current.children.length > 0) {
            const card = carouselRef.current.children[0];
            const cardWidth = card.getBoundingClientRect().width;
            setSlideWidth(cardWidth);
        }
    }, [data]);

    const scrollLeft = () => {
        if (carouselRef.current) {
            carouselRef.current.scrollBy({
                left: -slideWidth,
                behavior: 'smooth'
            });
        }
    };

    const scrollRight = () => {
        if (carouselRef.current) {
            carouselRef.current.scrollBy({
                left: slideWidth,
                behavior: 'smooth'
            });
        }
    };
    return (
        <div className='offerCarMobileMainContainer'>
            <div className='offerCardMobile' ref={carouselRef}>
                {data?.map((offerItem) => (
                    <div
                        key={offerItem._id}
                        className='offerCardContent'
                        onClick={() => handleOfferCardClick(offerItem._id)}
                    >
                        <div className='offerCardTextAndValidity'>
                            <div className='offer-card-button-container'>
                                <span className='titleText'>Trip</span>
                            </div>
                            <div className='offer-card-validityText'>
                                <TimmerIcon className='timerIcon' />
                                <span className='offer-card-validText'>
                                    Validity: {`${getFormattedDateReverse(offerItem?.endsAt) ?? 'N/A'}`}
                                </span>
                            </div>
                        </div>
                        <div className='offer-card-saveUpToText'>
                            <span>Save up to ₹{offerItem?.limit}</span>
                        </div>
                        <div className='offer-card-couponCode-Container'>
                            <button className='offer-card-offerTag'>
                                <OfferTag width={18} height={18} />
                            </button>
                            <span>{offerItem?.code}</span>
                        </div>
                    </div>
                ))}
            </div>
            <div className='offerCardScrollButton'>
                <button className='carouselBtn' onClick={scrollLeft}>
                    <LeftInActive />
                </button>
                <button className='carouselBtn active' onClick={scrollRight}>
                    <RightActive />
                </button>
            </div>
        </div>
    );
};

export default MobileOffferSection;
